var $ = require('jquery');

web = window.web = window.web || {};

web.SlideLinks = module.exports = function(options) {
    var t = this;

    setTimeout(function () {
        t.instanceState = 'constructed';
        var loader = document.getElementById("loader");
        if (loader) loader.style.display = 'none';
    }, 1000);

    t.defaults = {
        anyDefaultOption: true
    };

    t.interval = 490;

    t.options = $.extend({}, t.defaults, options);
};

web.SlideLinks.prototype = {
    init:  function(){
        var t = this;
        t.instanceState = 'inicialized';

        t._bindEvents();

    },


    setInterval: function(interval){
        var t = this;

        t.interval = interval;
    },

    getInterval: function(){
        var t = this;

        return t.interval;
    },

    _bindEvents: function(){
        var t = this;

        t.instanceState = 'binded';

        //on ready
        t._checkHashParamsInUrl();

        $("body").on("click", ".js_slideLinks-button", function(e){
            var $t = $(this);
            var data = $t.data();

            if ($("#"+data.slideLinksTarget).length != 0) {
                t.processSlideLink(data, $t);

                e.preventDefault();
            }
        });

        $("body").on("click", ".js_slideLinks-closeAllOthers", function(e){
            var $t = $(this);
            t._closeAllOthers($t);
        });

        $("body").on("click", ".js_slideLinks-closeAllOthers-afterOpenThis", function(e){
            var $t = $(this);
            var data = $t.data();
            t._closeAllOthers($t, function(){
                if ($("#"+data.slideLinksTarget).length != 0) {
                    t.processSlideLink(data, $t);
                }
            });
            e.preventDefault();
        });

        $("body").on("click", ".js_slideLinks-button-onlyOpen", function(e){
            var $t = $(this);
            var data = $t.data();

            var $elm = $("#"+data.slideLinksTarget);

            if ($elm.length != 0) {
                var _t = $elm.data("slideLinksOpened");
                if (typeof _t == 'undefined' || _t ==false) {
                    t.processSlideLink(data, $t);
                }

                e.preventDefault();
            }
        });



        $("body").on("click", ".js_slideLinks-button-onlyClose", function(e){
            var $t = $(this);
            var data = $t.data();

            var $elm = $("#"+data.slideLinksTarget);

            if ($elm.length != 0) {
                var _t = $elm.data("slideLinksOpened");
                if (!(typeof _t == 'undefined' || _t ==false)) {
                    t.processSlideLink(data, $t);
                }

                e.preventDefault();
            }
        });


    },

    _unBindEvents: function(){
        var t = this;

        t.instanceState = 'unbinded';
    },

    processSlideLink: function(data, $btn){
        var t = this;


        if (typeof data != 'undefined') {
            if (typeof data.slideLinksTarget != 'undefined') {
                t._procesSliding($("#"+data.slideLinksTarget), $btn, data);
            }
        }
    },

    _procesSliding: function($elm, $btn, data){
        var t = this;

        var _elmData = $elm.data("slideLinksOpened");

        if ($elm.html().trim().length > 0) {
            if (typeof _elmData == 'undefined') {
                t._slideDown($elm, $btn, data);
            } else if (_elmData == false) {
                t._slideDown($elm, $btn, data);
            } else {
                t._slideUp($elm, $btn, data);
            }
        }

    },

    _slideDown: function($elm, $btn, data){
        var t = this;
        $elm.removeClass("hidden").hide();

        $(t).trigger({
            type: "beforeSlideDown",
            btnElement:$btn,
            slideElement: $elm,
            data: data
        });
        $elm.slideDown(t.interval, null, function(){
            $elm.data("slideLinksOpened", true);
            t._toggleBtnClass($btn, 'opened');
            t._toggleBtnText($btn, data, 'Opened');

            $(t).trigger({
                type: "afterSlideDown",
                btnElement:$btn,
                slideElement: $elm,
                data: data
            });
        });
    },

    _slideUp: function($elm, $btn, data, callback){
        var t = this;
        if (typeof callback == 'undefined') var callback = function(){};

        if ($elm.data("slideLinksOpened")) {

            $(t).trigger({
                type: "beforeSlideUp",
                btnElement:$btn,
                slideElement: $elm,
                data: data
            });
            $elm.slideUp(t.interval, null, function(){
                $elm.data("slideLinksOpened", false);
                t._toggleBtnClass($btn, 'opened');
                t._toggleBtnText($btn, data, 'NotOpened');
                $(t).trigger({
                    type: "afterSlideUp",
                    btnElement:$btn,
                    slideElement: $elm,
                    data: data
                });
                callback();
            });
        } else {
            callback();
        }

        //if ($elm.data("slideLinksOpened") == false) {
        //
        //}

    },

    _toggleBtnClass: function($btn, className){
        var t = this;

        $btn.toggleClass(className);
    },

    _toggleBtnText: function($btn, data, type){
        var t = this;
        var _customTextElm= $btn.find(".js_slideLinks-customTitle");

        if (_customTextElm.length > 0) {
            if (typeof data.customTitleForNotOpened != 'undefined') {
                if (typeof data.customTitleForOpened != 'undefined') {
                    _customTextElm.text(data['customTitleFor'+type]);
                }
            }
        }

    },

    _getOpenedElements: function(exept){
        var t = this;

        var $elements = $("body").find("*[data-slide-links-target]");

        var ret = [];
        var opened = 0;
        $elements.each(function(i){
            var $item = $(this);
            var $target = $("#"+$item.data("slideLinksTarget"));

            if (typeof exept != 'undefined') {
                if ($item.data("slideLinksTarget") != exept.data("slideLinksTarget")) {
                    if (!!$target.data("slideLinksOpened")) {
                        ret.push($item);
                    }
                }
            } else {
                if (!!$target.data("slideLinksOpened")) {
                    ret.push($item);
                }
            }


        });

        return ret;
    },

    closeAll: function(group) {
        var t = this;

        var openedElemnts = t._getOpenedElements();
        var index = 0;
        for (var i in openedElemnts){
            var $item = openedElemnts[i];
            var $target = $("#"+$item.data("slideLinksTarget"));

            t._slideUp($target,$item,$item.data());

            index=index+1;
        }


    },

    _closeAllOthers: function(exept, callback){
        var t = this;

        if (typeof callback == 'undefined') var callback = function(){};


//        var $elements = $("body").find("*[data-slide-links-target]");
//
//        $elements.each(function(i){
//            var $item = $(this);
//            var $target = $("#"+$item.data("slideLinksTarget"));
//
//            if ($item.data("slideLinksTarget") != exept.data("slideLinksTarget")) {
//                if (!!$target.data("slideLinksOpened")) {
//                    t._slideUp($target,$item,null);
//                }
//            }
//        });


        var openedElemnts = t._getOpenedElements(exept);
        var index = 0;
        for (var i in openedElemnts){
            var $item = openedElemnts[i];
            var $target = $("#"+$item.data("slideLinksTarget"));


            if (index == openedElemnts.length-1) {
                t._slideUp($target,$item,$item.data(),callback);
            } else {
                t._slideUp($target,$item,$item.data());
            }
            index=index+1;
        }

        if (openedElemnts.length == 0) {
            callback();
        }

    },

    _checkHashParamsInUrl: function(){
        var t = this;
        var hash = window.location.hash;
        var toGo = "";
        var parts = [];
        if (hash) {
            parts = hash.split("#");
        }
        for (var i in parts) {
            var part = parts[i];

            if (part.indexOf("slideLinks") != -1) {
                toGo=part;
            }
        }
        //console.log(toGo);

        if (toGo != "") {
            var data = {
                slideLinksTarget: toGo
            }
            t.processSlideLink(data, $("<span></span>"));
        }


    }



}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/SlideLinks.js